import React, { useState } from 'react';
import HelloWorldButton from './components/HelloWorldButton';
import './styles/App.css';
import Footer from "./components/Footer";

const App: React.FC = () => {
    const [message, setMessage] = useState<string>('');
    const [buttonText, setButtonText] = useState<string>('Find Nostalgia');
    const [selectedDecade, setSelectedDecade] = useState<string>('90s');
    const [selectedContentType, setSelectedContentType] = useState<string>('product');
    const [link, setLink] = useState<string>('');
    const [fullLink, setFullLink] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleButtonClick = async () => {
        setIsLoading(true);
        setMessage('');
        setLink('');
        setFullLink('');
        try {
            var fetchUrl = `https://lqb3zx9ju1.execute-api.us-east-2.amazonaws.com/prod/nostalgia?decade=${selectedDecade}&contentType=${selectedContentType}`;
            const response = await fetch(fetchUrl, {
                method: 'GET',
                headers: {
                    'X-Api-Key': process.env.REACT_APP_API_KEY as string
                },
            });
            const responseData = await response.json();
            console.log(responseData);
            setMessage('The nostalgia you seek is here:');
            const fullLink = responseData.snLink.startsWith('http') ? responseData.snLink : `http://${responseData.snLink}`;
            setFullLink(fullLink);
            setLink(fullLink.length > 50 ? `${fullLink.substring(0, 50)}...` : fullLink);
            setButtonText('Find Nostalgia');
        } catch (error) {
            setMessage('Error fetching data');
            setButtonText('Try Again');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDecadeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedDecade(event.target.value);
    };

    const handleContentTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedContentType(event.target.value);
    };

    return (
        <div id="body">
            <div className="container">
                <h1>Seek Nostalgia</h1>
                <p>Generate instant links to the nostalgic content you seek!</p>
                <label htmlFor="decade-select">Select a decade: </label>
                <select id="decade-select" value={selectedDecade} onChange={handleDecadeChange}>
                    <option value="50s">50's</option>
                    <option value="60s">60's</option>
                    <option value="70s">70's</option>
                    <option value="80s">80's</option>
                    <option value="90s">90's</option>
                    <option value="00s">00's</option>
                </select>
                <br />
                <label htmlFor="content-type-select">Select content type: </label>
                <select id="content-type-select" value={selectedContentType} onChange={handleContentTypeChange}>
                    <option value="product">Product</option>
                    <option value="image">Image</option>
                    <option value="video">Video</option>
                </select>
                <br />
                <HelloWorldButton onClick={handleButtonClick} text={buttonText} />
                {isLoading && <div className="loader"></div>}
                <div>
                    {message && <h2>{message}</h2>}
                    {link && <a href={fullLink} target="_blank" rel="noopener noreferrer">{link}</a>}
                </div>
                <Footer />
            </div>   
        </div>   
    );
};

export default App;